module.exports = __webpack_public_path__ + "img/chat.d65e06de.png";